import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CoreFeature from './CoreFeature';

function ChartsReporting() {
   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);



   return (


      <>
         <Helmet>
            <title>Charts and Reporting Management | Taskflier</title>
         </Helmet>
            <div class="block-style-thirtySix bg-white lg-container pt-110 " id="feature">
               <div class="container">
                  <div class="row">
                     <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
                        <div class="pl-lg-5">
                           <div class="title-style-fourteen">
                              <h6><span class="upper-title custom-name">Charts Reporting</span></h6>
                              <h1>See your project’s progress and status graphically</h1>
                           </div>
                           <div class="tag-line">Charts and reports help managers visualize project progress as and when needed. TeaskFlier’s Charts & Reporting feature provides rich sets of meaningful charts to visually assess projects and manage teams effectively. Multi-level detailed reports show the progress of the project, providing clear information helping you understand what’s happening and make smart decisions necessary to keep everything on track.</div>

                        </div>
                     </div>
                     <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
                        <div class="illustration-holder d-inline-block md-mt-60">
                           <img src="/main/images/dashboard.png" alt="" class="w-100" />
                           <img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one" />
                           <img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two" />
                           <img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>



            <div class="fancy-feature-ten pt-80 bg-white" id="feature">
               <div class="bg-wrapper pt-80">
                  <div class="container">

                     <div class="row features justify-content-center">


                        <div class="col-lg-4 col-12 ">

                           <div class="Solutions-box " >
                              <img src="/main/images/task-creation.png" alt="Task creation" class="w-100" />
                              <div class="pack-name mt-3 text-capitalize">Interactive Charts</div>
                              <hr></hr>
                              <p className="mainp">The Charts & Reporting features of TaskFlier enable users to engage with data dynamically—hover for details, click to drill down, or filter by category. This real-time interactivity enhances understanding, uncovers trends, and supports faster, informed decisions. It transforms static reports into powerful tools for tracking progress and team performance.</p>


                           </div>

                        </div>
                        <div class="col-lg-4 col-12 ">

                           <div class="Solutions-box " >
                              <img src="/main/images/customizing-taskboard.png" alt="Customizing taskboard" class="w-100" />
                              <div class="pack-name mt-3 text-capitalize">Customizable Charts
                              </div>
                              <hr></hr>
                              <p className="mainp">TaskFlier’s Charts & Reporting features provide charts in project management which users can tailor visual data representations to their specific needs. Managers can choose chart types, adjust colors, set filters, and define metrics to focus on key project areas improving clarity, aligning insights with goals and enhancing overall project tracking and communication.</p>

                           </div>

                        </div>
                        <div class="col-lg-4 col-12 ">

                           <div class="Solutions-box " >
                              <img src="/main/images/task-dependencies.png" alt="Task dependencies" class="w-100" />
                              <div class="pack-name mt-3 text-capitalize">Advanced Reporting</div>
                              <hr></hr>
                              <p className="mainp">TaskFlier’s Charts & Reporting features are capable of generating unique reports that highlight mission milestones, closing dates, and aid utilization. Various filters can be used to focus on specific responsibilities, time durations, or team contributors, and perceive trends or capability bottlenecks.</p>


                           </div>
                        </div>
                        <div class="col-lg-4 col-12 ">

                           <div class="Solutions-box " >
                              <img src="/main/images/task-creation.png" alt="Task creation" class="w-100" />
                              <div class="pack-name mt-3 text-capitalize">Automated Report Scheduling</div>
                              <hr></hr>
                              <p className="mainp">Charts & Reporting’s automated feature enables managers to generate and deliver reports at set intervals (weekly, monthly or quarterly) without manual effort and get delivered into mailboxes of the stakeholders. Teams receive timely updates on tasks, budgets, and milestones, ensuring that everyone stays informed boosting efficiency, supporting proactive decision-making, and maintaining consistent communication across projects and stakeholders.</p>


                           </div>

                        </div>
                        <div class="col-lg-4 col-12 ">

                           <div class="Solutions-box " >
                              <img src="/main/images/customizing-taskboard.png" alt="Customizing taskboard" class="w-100" />
                              <div class="pack-name mt-3 text-capitalize">Real-Time Sync
                              </div>
                              <hr></hr>
                              <p className="mainp">TaskFlier’s Charts & Reports feature gets updated in real-time keeping your reviews correct and updated with actual-time facts syncing. As team members make progress, your charts and reports mirror it immediately. It never leaves out crucial updates and continually have the modern facts available for selection-making.</p>

                           </div>

                        </div>
                        <div class="col-lg-4 col-12 ">

                           <div class="Solutions-box " >
                              <img src="/main/images/task-dependencies.png" alt="Task dependencies" class="w-100" />
                              <div class="pack-name mt-3 text-capitalize">Data Export Options</div>
                              <hr></hr>
                              <p className="mainp">Charts & Reporting’s can export charts and reports in suitable formats including PDF, Excel, CSV, etc. for clean sharing and integration with different applications and platforms presenting information efficaciously to stakeholders or customers as and when necessary.</p>


                           </div>
                        </div>



                     </div>

                  </div>

               </div>
            </div>


            <div class="fancy-feature-twentyNine lg-container  pt-80 md-mt-70 bg-white" id="p-tour">

               <div class="container">

                  <div class="block-style-thirty">
                     <div class="row">
                        <div class="col-xl-5 col-lg-6 order-lg-last">
                           <div class="text-block md-pb-60">

                              <div class="title-style-nine mb-45 md-mb-30">

                              </div>
                              <p>Transform uncooked assignment data into actionable insights with TaskFlier’s Charts & Reports. Whether you’re overseeing an unmarried assignment or coping with multiple groups, our functions make it easy to stay organized, tune key metrics, and acquire your dreams correctly.

                              </p>


                           </div>
                        </div>
                        <div class="col-xl-7 col-lg-6 order-lg-first">
                           <img src="/images/assets/screen_36.png" alt="" />
                        </div>
                     </div>
                  </div>

               </div>
            </div>


            <CoreFeature />
            <div className="faq-classic pt-0 bg-white">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-12">
                        <div className="title-style-one mb-40">
                           <h6 className="font-rubik">Find your answers</h6>
                           <h2>Have any thought? Look here.</h2>
                        </div>
                     </div>
                     <div className="col-lg-12">
                        <div id="accordion" className="md-mt-60">
                           <div className="card">
                              <div className="card-header" id="headingOne">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseOne"
                                       aria-expanded="true"
                                       aria-controls="collapseOne"
                                    >
                                       What does the Charts & Reporting feature offer?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseOne"
                                 className="accordion-collapse collapse show"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       The Charts & Reporting feature provides dynamic, real-time visual dashboards and reports that help managers monitor performance, identify trends, and make data-driven decisions. It transforms complex data into easy-to-understand information and visuals.
                                    </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingTwo">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseTwo"
                                       aria-expanded="true"
                                       aria-controls="collapseTwo"
                                    >
                                       Are the reports generated by TaskFlier interactive or static?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseTwo"
                                 className="accordion-collapse collapse "
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>


                                       Reports and dashboards generated in TaskFlier are interactive. Users can click into charts to drill down for more details, apply filters on-the-fly, and hover over data points for context—all without leaving the report interface.
                                    </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseThree"
                                       aria-expanded="true"
                                       aria-controls="collapseThree"
                                    >
                                       How secure is the data used in reports?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseThree"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       All data processed in the Charts & Reporting module is protected with enterprise-grade security protocols including encrypted transmission, access control, and audit logging. You control who sees what through granular permissions.
                                    </p>


                                 </div>
                              </div>
                           </div>

                           <div className="card">
                              <div className="card-header" id="headingFour">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseFour"
                                       aria-expanded="true"
                                       aria-controls="collapseFour"
                                    >
                                       Is real-time data supported in reports and dashboards?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseFour"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       Absolutely. The platform pulls data from integrated sources in real time, ensuring your charts and reports reflect the most up-to-date information for accurate and responsive decision-making.
                                    </p>


                                 </div>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               </div>
            </div>

      </>

   )
}

export default ChartsReporting
